import script from "./SDOS.vue?vue&type=script&setup=true&lang=js"
export * from "./SDOS.vue?vue&type=script&setup=true&lang=js"

import "./SDOS.vue?vue&type=style&index=0&id=26fadfdb&scoped=true&lang=scss"

import exportComponent from "D:\\project\\2024\\htos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26fadfdb"]])

export default __exports__